import ApiCodeColored from './svg/Colored/API Code.es.js';
import AtmCardColored from './svg/Colored/ATM-card.es.js';
import AtmColored from './svg/Colored/ATM.es.js';
import BadgesColored from './svg/Colored/Badges.es.js';
import BankColored from './svg/Colored/Bank.es.js';
import CashColored from './svg/Colored/Cash.es.js';
import CircleBankColored from './svg/Colored/CircleBank.es.js';
import CircleCashColored from './svg/Colored/CircleCash.es.js';
import CircleMobileBankingColored from './svg/Colored/CircleMobile-Banking.es.js';
import CircleQrCodeColored from './svg/Colored/CircleQR-code.es.js';
import CircleShippingColored from './svg/Colored/CircleShipping.es.js';
import CircleShowroomColored from './svg/Colored/CircleShowroom.es.js';
import CircleVisaLogoColored from './svg/Colored/CircleVisa-logo.es.js';
import DeleteCircleColored from './svg/Colored/Delete-circle.es.js';
import DinoColored from './svg/Colored/Dino.es.js';
import DiscountTagColored from './svg/Colored/Discount-Tag.es.js';
import FireFlashsaleColored from './svg/Colored/Fire-Flashsale.es.js';
import FreeShippingColored from './svg/Colored/Free-Shipping.es.js';
import GoogleSheetColored from './svg/Colored/Google Sheet.es.js';
import GoogleGmailColored from './svg/Colored/google-gmail.es.js';
import GuaranteeCheckedColored from './svg/Colored/Guarantee-Checked.es.js';
import IndicatorColored from './svg/Colored/Indicator.es.js';
import LuckyDrawColored from './svg/Colored/LuckyDraw.es.js';
import LuckySpinColored from './svg/Colored/LuckySpin.es.js';
import MasterCardColored from './svg/Colored/Master-card.es.js';
import MobileBankingColored from './svg/Colored/Mobile-Banking.es.js';
import PaymentColored from './svg/Colored/Payment.es.js';
import PvShowroomColored from './svg/Colored/PV Showroom.es.js';
import QrCodeColored from './svg/Colored/QR-code.es.js';
import RewardGoldenColored from './svg/Colored/Reward Golden.es.js';
import RewardBronzeCircleColored from './svg/Colored/Reward-Bronze-Circle.es.js';
import RewardBronzeColored from './svg/Colored/Reward-Bronze.es.js';
import RewardGoldenCircleColored from './svg/Colored/Reward-Golden-Circle.es.js';
import RewardPlatinumCircleColored from './svg/Colored/Reward-Platinum-Circle.es.js';
import RewardPlatinumColored from './svg/Colored/Reward-Platinum.es.js';
import RewardSilverCircleColored from './svg/Colored/Reward-Silver-Circle.es.js';
import RewardSilverColored from './svg/Colored/Reward-Silver.es.js';
import SaleColored from './svg/Colored/Sale.es.js';
import ShippingColored from './svg/Colored/Shipping.es.js';
import ShopColored from './svg/Colored/Shop.es.js';
import ShoppingCartColored from './svg/Colored/Shopping cart.es.js';
import StarColored from './svg/Colored/Star.es.js';
import SuccessColored from './svg/Colored/Success.es.js';
import UsaColored from './svg/Colored/USA.es.js';
import VietnamColored from './svg/Colored/Vietnam.es.js';
import VisaCardColored from './svg/Colored/Visa-card.es.js';
import VisaLogoColored from './svg/Colored/Visa-logo.es.js';
import VoucherColored from './svg/Colored/Voucher.es.js';
import WalletColored from './svg/Colored/Wallet.es.js';
import AppListFilled from './svg/Filled/_AppList.es.js';
import DirectionFilled from './svg/Filled/_Direction.es.js';
import AccountFilled from './svg/Filled/Account.es.js';
import ArrowDownTinyFilled from './svg/Filled/Arrow Down Tiny.es.js';
import ArrowDownFilled from './svg/Filled/Arrow Down.es.js';
import ArrowLeftTinyFilled from './svg/Filled/Arrow Left Tiny.es.js';
import ArrowLeftFilled from './svg/Filled/Arrow Left.es.js';
import ArrowRightTinyFilled from './svg/Filled/Arrow Right Tiny.es.js';
import ArrowRightFilled from './svg/Filled/Arrow Right.es.js';
import ArrowUpTinyFilled from './svg/Filled/Arrow Up Tiny.es.js';
import ArrowUpFilled from './svg/Filled/Arrow Up.es.js';
import CalendarFilled from './svg/Filled/Calendar.es.js';
import CartFilled from './svg/Filled/cart.es.js';
import CautionFilled from './svg/Filled/Caution.es.js';
import ChevronDownFilled from './svg/Filled/ChevronDown.es.js';
import ChevronUpFilled from './svg/Filled/ChevronUp.es.js';
import ClockFilled from './svg/Filled/Clock.es.js';
import CopyFilled from './svg/Filled/copy.es.js';
import DeleteCircleFilled from './svg/Filled/Delete-circle.es.js';
import DeleteFilled from './svg/Filled/delete.es.js';
import DiscountTagFilled from './svg/Filled/Discount-Tag.es.js';
import DiscountFilled from './svg/Filled/Discount.es.js';
import DoubleArrowTinyFilled from './svg/Filled/Double Arrow Tiny.es.js';
import DoubleArrowFilled from './svg/Filled/Double-Arrow.es.js';
import EditFilled from './svg/Filled/edit.es.js';
import EyeHideFilled from './svg/Filled/Eye-Hide.es.js';
import EyeShowFilled from './svg/Filled/Eye-Show.es.js';
import FacebookMessengerFilled from './svg/Filled/Facebook-messenger.es.js';
import FacebookFilled from './svg/Filled/facebook.es.js';
import FavouriteFilled from './svg/Filled/Favourite.es.js';
import FilterFilled from './svg/Filled/Filter.es.js';
import FlashSaleFilled from './svg/Filled/Flash sale.es.js';
import FlashOffFilled from './svg/Filled/Flash-off.es.js';
import FlashOnFilled from './svg/Filled/Flash-on.es.js';
import FourColumnsDevFilled from './svg/Filled/FourColumnsDev.es.js';
import GarbageFilled from './svg/Filled/Garbage.es.js';
import GithubFilled from './svg/Filled/github.es.js';
import GlobalFilled from './svg/Filled/Global.es.js';
import GoogleFilled from './svg/Filled/google.es.js';
import HighlightBackgroundFilled from './svg/Filled/HighlightBackground.es.js';
import HomepageFilled from './svg/Filled/Homepage.es.js';
import ImageFilled from './svg/Filled/Image.es.js';
import InforFilled from './svg/Filled/Infor.es.js';
import InstagramFilled from './svg/Filled/Instagram.es.js';
import LayerFilled from './svg/Filled/layer.es.js';
import LeftAndRightSidebarDevFilled from './svg/Filled/LeftAndRightSidebarDev.es.js';
import LeftSidebarDevFilled from './svg/Filled/LeftSidebarDev.es.js';
import MoreProductFilled from './svg/Filled/More-product.es.js';
import NotificationFilled from './svg/Filled/Notification.es.js';
import NumberCounterFilled from './svg/Filled/NumberCounter.es.js';
import OneColumnDevFilled from './svg/Filled/OneColumnDev.es.js';
import OptionsFilled from './svg/Filled/options.es.js';
import OrderFilled from './svg/Filled/Order.es.js';
import PbCallFilled from './svg/Filled/PBCall.es.js';
import PbInpageLinkFilled from './svg/Filled/PBInpageLink.es.js';
import PbMailFilled from './svg/Filled/PBMail.es.js';
import PbNavigationCurvedFilled from './svg/Filled/PBNavigationCurved.es.js';
import PbNavigationRoundFilled from './svg/Filled/PBNavigationRound.es.js';
import PbPaginationDotBigFilled from './svg/Filled/PBPaginationDotBig.es.js';
import PbPaginationDotLineFilled from './svg/Filled/PBPaginationDotLine.es.js';
import PbPaginationDotsFilled from './svg/Filled/PBPaginationDots.es.js';
import PbPaginationLineFilled from './svg/Filled/PBPaginationLine.es.js';
import PbSliderOneRowFilled from './svg/Filled/PBSliderOneRow.es.js';
import PbSliderThreeRowFilled from './svg/Filled/PBSliderThreeRow.es.js';
import PbSliderTwoRowFilled from './svg/Filled/PBSliderTwoRow.es.js';
import PhoneFilled from './svg/Filled/Phone.es.js';
import ProfileFilled from './svg/Filled/Profile.es.js';
import PromoFilled from './svg/Filled/Promo.es.js';
import RatingFilled from './svg/Filled/Rating.es.js';
import RightSidebarDevFilled from './svg/Filled/RightSidebarDev.es.js';
import SaveFilled from './svg/Filled/save.es.js';
import SettingsFilled from './svg/Filled/settings.es.js';
import SixColumnDevFilled from './svg/Filled/SixColumnDev.es.js';
import SliderFilled from './svg/Filled/Slider.es.js';
import SuccessFilled from './svg/Filled/Success.es.js';
import ThreeColumnsDevFilled from './svg/Filled/ThreeColumnsDev.es.js';
import TickFilled from './svg/Filled/tick.es.js';
import TiktokFilled from './svg/Filled/Tiktok.es.js';
import TwitterFilled from './svg/Filled/twitter.es.js';
import TwoColumnsFilled from './svg/Filled/TwoColumns.es.js';
import TwoColumnsDevFilled from './svg/Filled/TwoColumnsDev.es.js';
import TwoSmallColumnLeftDevFilled from './svg/Filled/TwoSmallColumnLeftDev.es.js';
import TwoSmallColumnRightDevFilled from './svg/Filled/TwoSmallColumnRightDev.es.js';
import VoucherFilled from './svg/Filled/Voucher.es.js';
import YoutubeFilled from './svg/Filled/youtube.es.js';
import ZaloFilled from './svg/Filled/Zalo.es.js';
import AddAlternativeOutlined from './svg/Outlined/_AddAlternative.es.js';
import ClockAlternativeOutlined from './svg/Outlined/_ClockAlternative.es.js';
import DirectionAlternativeOutlined from './svg/Outlined/_DirectionAlternative.es.js';
import FavouriteAlternativeOutlined from './svg/Outlined/_FavouriteAlternative.es.js';
import FormScaleAlternativeOutlined from './svg/Outlined/_Form-scaleAlternative.es.js';
import HomepageAlternativeOutlined from './svg/Outlined/_HomepageAlternative.es.js';
import LaptopAlternativeOutlined from './svg/Outlined/_LaptopAlternative.es.js';
import MarkAsReadAlternativeOutlined from './svg/Outlined/_Mark-as-readAlternative.es.js';
import RatingAlternativeOutlined from './svg/Outlined/_RatingAlternative.es.js';
import SettingAlternativeOutlined from './svg/Outlined/_SettingAlternative.es.js';
import SuccessAlternativeOutlined from './svg/Outlined/_SuccessAlternative.es.js';
import AccordionOutlined from './svg/Outlined/accordion.es.js';
import AccountOutlined from './svg/Outlined/Account.es.js';
import AddItemOutlined from './svg/Outlined/Add-item.es.js';
import AddOutlined from './svg/Outlined/Add.es.js';
import AdvisoryOutlined from './svg/Outlined/Advisory.es.js';
import AlignCenterOutlined from './svg/Outlined/align-center.es.js';
import AlignJustifyOutlined from './svg/Outlined/align-justify.es.js';
import AlignLeftOutlined from './svg/Outlined/align-left.es.js';
import AlignRightOutlined from './svg/Outlined/align-right.es.js';
import ArrowUpOutlined from './svg/Outlined/ArrowUp.es.js';
import BackToTopOutlined from './svg/Outlined/Back-to-top.es.js';
import BackOutlined from './svg/Outlined/Back.es.js';
import BagCheckmarkOutlined from './svg/Outlined/bag checkmark.es.js';
import BlockGroupOutlined from './svg/Outlined/BlockGroup.es.js';
import BoldOutlined from './svg/Outlined/Bold.es.js';
import BookOutlined from './svg/Outlined/Book.es.js';
import BoxOutlined from './svg/Outlined/box.es.js';
import BuildPcOutlined from './svg/Outlined/buildPc.es.js';
import BulletedListOutlined from './svg/Outlined/BulletedList.es.js';
import BusinessCustomerOutlined from './svg/Outlined/Business-customer.es.js';
import BusinessSolutionOutlined from './svg/Outlined/Business-solution.es.js';
import ButtonOutlined from './svg/Outlined/button.es.js';
import CalculatorOutlined from './svg/Outlined/Calculator.es.js';
import CalendarOutlined from './svg/Outlined/Calendar.es.js';
import CalendarWorkForWeekOutlined from './svg/Outlined/CalendarWorkForWeek.es.js';
import CameraOutlined from './svg/Outlined/Camera.es.js';
import CartOutlined from './svg/Outlined/cart.es.js';
import CashOutlined from './svg/Outlined/Cash.es.js';
import CautionOutlined from './svg/Outlined/Caution.es.js';
import ChatOutlined from './svg/Outlined/Chat.es.js';
import CheckOutlined from './svg/Outlined/Check.es.js';
import ChecklistOutlined from './svg/Outlined/Checklist.es.js';
import ChevronDownOutlined from './svg/Outlined/ChevronDown.es.js';
import ChevronUpOutlined from './svg/Outlined/ChevronUp.es.js';
import ChipOutlined from './svg/Outlined/Chip.es.js';
import CircleBackOutlined from './svg/Outlined/Circle-Back.es.js';
import CircleDownOutlined from './svg/Outlined/Circle-Down.es.js';
import CircleForwardOutlined from './svg/Outlined/Circle-Forward.es.js';
import CircleUpOutlined from './svg/Outlined/Circle-Up.es.js';
import CloseOutlined from './svg/Outlined/Close.es.js';
import CloudArrowUpOutlined from './svg/Outlined/CloudArrowUp.es.js';
import CodeOutlined from './svg/Outlined/code.es.js';
import ColorSwitchOutlined from './svg/Outlined/ColorSwitch.es.js';
import ContentSettingsOutlined from './svg/Outlined/ContentSettings.es.js';
import CopyOutlined from './svg/Outlined/Copy.es.js';
import CustomerSupportOutlined from './svg/Outlined/Customer-support.es.js';
import DataTreemapOutlined from './svg/Outlined/DataTreemap.es.js';
import DeleteOutlined from './svg/Outlined/delete.es.js';
import DeleteColumnOutlined from './svg/Outlined/DeleteColumn.es.js';
import DeleteRowOutlined from './svg/Outlined/DeleteRow.es.js';
import DesktopOutlined from './svg/Outlined/Desktop.es.js';
import DinoOutlined from './svg/Outlined/Dino.es.js';
import DiscountTagOutlined from './svg/Outlined/Discount-Tag.es.js';
import DiscountOutlined from './svg/Outlined/Discount.es.js';
import DividerOutlined from './svg/Outlined/Divider.es.js';
import DocumentOutlined from './svg/Outlined/Document.es.js';
import DotOutlined from './svg/Outlined/Dot.es.js';
import DownLineOutlined from './svg/Outlined/Down-Line.es.js';
import DownOutlined from './svg/Outlined/Down.es.js';
import DownloadOutlined from './svg/Outlined/Download.es.js';
import DragOutlined from './svg/Outlined/Drag.es.js';
import DragdropOutlined from './svg/Outlined/Drag_Drop.es.js';
import DuplicateOutlined from './svg/Outlined/duplicate.es.js';
import EditColumnOutlined from './svg/Outlined/Edit Column.es.js';
import EditSquareOutlined from './svg/Outlined/Edit Square.es.js';
import EditOutlined from './svg/Outlined/Edit.es.js';
import EndShiftOutlined from './svg/Outlined/EndShift.es.js';
import ExportFileOutlined from './svg/Outlined/ExportFile.es.js';
import EyeOutlined from './svg/Outlined/Eye.es.js';
import FaceIdOutlined from './svg/Outlined/FaceID.es.js';
import FileOutlined from './svg/Outlined/File.es.js';
import FillColorShapeOutlined from './svg/Outlined/FillColorShape.es.js';
import FillColorTextOutlined from './svg/Outlined/FillColorText.es.js';
import FilterOutlined from './svg/Outlined/Filter.es.js';
import FingerPrintOutlined from './svg/Outlined/Finger-print.es.js';
import FluentButtonOutlined from './svg/Outlined/FluentButton.es.js';
import FluentLinkOutlined from './svg/Outlined/FluentLink.es.js';
import FormOutlined from './svg/Outlined/form.es.js';
import FormatTextLeftOutlined from './svg/Outlined/FormatTextLeft.es.js';
import FormatTextRightOutlined from './svg/Outlined/FormatTextRight.es.js';
import ForwardOutlined from './svg/Outlined/Forward.es.js';
import GamingOutlined from './svg/Outlined/Gaming.es.js';
import GarbageOutlined from './svg/Outlined/Garbage.es.js';
import GoldOutlined from './svg/Outlined/Gold.es.js';
import GuaranteeCheckedOutlined from './svg/Outlined/Guarantee-Checked.es.js';
import HamburgerOutlined from './svg/Outlined/Hamburger.es.js';
import HeaderOutlined from './svg/Outlined/header.es.js';
import HeadingOutlined from './svg/Outlined/heading.es.js';
import HeadphoneOutlined from './svg/Outlined/Headphone.es.js';
import HideOutlined from './svg/Outlined/Hide.es.js';
import HOneOutlined from './svg/Outlined/HOne.es.js';
import HThreeOutlined from './svg/Outlined/HThree.es.js';
import HTwoOutlined from './svg/Outlined/HTwo.es.js';
import IdCardOutlined from './svg/Outlined/ID Card.es.js';
import ImageOutlined from './svg/Outlined/Image.es.js';
import InforOutlined from './svg/Outlined/Infor.es.js';
import InsertColumnAfterOutlined from './svg/Outlined/InsertColumnAfter.es.js';
import InsertColumnBeforeOutlined from './svg/Outlined/InsertColumnBefore.es.js';
import InsertRowAboveOutlined from './svg/Outlined/InsertRowAbove.es.js';
import InsertRowBelowOutlined from './svg/Outlined/InsertRowBelow.es.js';
import InstallmentOutlined from './svg/Outlined/Installment.es.js';
import InstallmentCalendarOutlined from './svg/Outlined/InstallmentCalendar.es.js';
import InternetOutlined from './svg/Outlined/Internet.es.js';
import ItalicOutlined from './svg/Outlined/Italic.es.js';
import JumpForwardOutlined from './svg/Outlined/Jump Forward.es.js';
import JumpBackOutlined from './svg/Outlined/Jump-Back.es.js';
import JumpForwardAlternativeOutlined from './svg/Outlined/Jump-ForwardAlternative.es.js';
import LeftLineOutlined from './svg/Outlined/Left-Line.es.js';
import LeftOutlined from './svg/Outlined/Left.es.js';
import LineOutlined from './svg/Outlined/Line.es.js';
import LineDashedOutlined from './svg/Outlined/LineDashed.es.js';
import LineDottedOutlined from './svg/Outlined/LineDotted.es.js';
import LineThroughOutlined from './svg/Outlined/LineThrough.es.js';
import LinkOutlined from './svg/Outlined/Link.es.js';
import ListLocationOutlined from './svg/Outlined/list Location.es.js';
import ListOutlined from './svg/Outlined/List.es.js';
import LocationOutlined from './svg/Outlined/Location.es.js';
import LockOutlined from './svg/Outlined/Lock.es.js';
import LogOutOutlined from './svg/Outlined/Log-out.es.js';
import LoyaltyOutlined from './svg/Outlined/loyalty.es.js';
import MailOutlined from './svg/Outlined/Mail.es.js';
import MenuOutlined from './svg/Outlined/Menu.es.js';
import MinusCircleOutlined from './svg/Outlined/Minus-circle.es.js';
import MinusRetangleOutlined from './svg/Outlined/Minus-retangle.es.js';
import MinusOutlined from './svg/Outlined/Minus.es.js';
import MobileAndDesktopOutlined from './svg/Outlined/Mobile and Desktop.es.js';
import MobiphoneOutlined from './svg/Outlined/Mobiphone.es.js';
import MoneyTransferOutlined from './svg/Outlined/Money-Transfer.es.js';
import MonitorOutlined from './svg/Outlined/Monitor.es.js';
import MoreInforOutlined from './svg/Outlined/More infor.es.js';
import MoreProductOutlined from './svg/Outlined/More-product.es.js';
import NewsOutlined from './svg/Outlined/News.es.js';
import NoneOutlined from './svg/Outlined/None.es.js';
import NotificationsOutlined from './svg/Outlined/Notifications.es.js';
import NumberedListOutlined from './svg/Outlined/NumberedList.es.js';
import OrderOutlined from './svg/Outlined/Order.es.js';
import PageOutlined from './svg/Outlined/Page.es.js';
import ParagraphOutlined from './svg/Outlined/paragraph.es.js';
import PauseOutlined from './svg/Outlined/pause.es.js';
import PaymentOutlined from './svg/Outlined/Payment.es.js';
import PbArrowLeftOutlined from './svg/Outlined/PB Arrow Left.es.js';
import PbLinkOutlined from './svg/Outlined/pb-link.es.js';
import PbUnlinkOutlined from './svg/Outlined/pb-unlink.es.js';
import PcOutlined from './svg/Outlined/PC.es.js';
import PhoneOutlined from './svg/Outlined/Phone.es.js';
import PlayOutlined from './svg/Outlined/Play 1.es.js';
import PlusCircleOutlined from './svg/Outlined/Plus-circle.es.js';
import PlusRetangleOutlined from './svg/Outlined/Plus-retangle.es.js';
import PopupOutlined from './svg/Outlined/popup.es.js';
import PrinterOutlined from './svg/Outlined/Printer.es.js';
import ProductOutlined from './svg/Outlined/Product.es.js';
import ProfileOutlined from './svg/Outlined/Profile.es.js';
import PromoOutlined from './svg/Outlined/Promo.es.js';
import PromoDiscountOutlined from './svg/Outlined/PromoDiscount.es.js';
import QaOutlined from './svg/Outlined/Q_A.es.js';
import QrCodeScanOutlined from './svg/Outlined/QRCode Scan.es.js';
import RamOutlined from './svg/Outlined/Ram.es.js';
import RedoOutlined from './svg/Outlined/Redo.es.js';
import RefreshOutlined from './svg/Outlined/Refresh.es.js';
import RefundOutlined from './svg/Outlined/Refund.es.js';
import ResizeSmallOutlined from './svg/Outlined/ResizeSmall.es.js';
import ReturnItemOutlined from './svg/Outlined/Return item.es.js';
import RightLineOutlined from './svg/Outlined/Right-Line.es.js';
import RightOutlined from './svg/Outlined/Right.es.js';
import RowTripleOutlined from './svg/Outlined/RowTriple.es.js';
import SaveOutlined from './svg/Outlined/Save.es.js';
import ScanningOutlined from './svg/Outlined/Scanning.es.js';
import SearchOutlined from './svg/Outlined/Search.es.js';
import SettingsOutlined from './svg/Outlined/settings.es.js';
import ShareOutlined from './svg/Outlined/Share.es.js';
import ShieldOutlined from './svg/Outlined/Shield.es.js';
import ShippingOutlined from './svg/Outlined/Shipping.es.js';
import ShopOutlined from './svg/Outlined/Shop.es.js';
import ShoppingCartOutlined from './svg/Outlined/Shopping cart.es.js';
import ShortingOutlined from './svg/Outlined/Shorting.es.js';
import ShowOutlined from './svg/Outlined/Show.es.js';
import ShowroomOutlined from './svg/Outlined/showroom.es.js';
import SlideTextOutlined from './svg/Outlined/SlideText.es.js';
import SpacerOutlined from './svg/Outlined/Spacer.es.js';
import SpeakerOutlined from './svg/Outlined/Speaker.es.js';
import SplitHorizontalOutlined from './svg/Outlined/SplitHorizontal.es.js';
import SquareMultipleOutlined from './svg/Outlined/SquareMultiple.es.js';
import StarEmphasisOutlined from './svg/Outlined/StarEmphasis.es.js';
import StopOutlined from './svg/Outlined/stop.es.js';
import SwitchOutlined from './svg/Outlined/Switch.es.js';
import SyncOutlined from './svg/Outlined/Sync.es.js';
import TabOutlined from './svg/Outlined/tab.es.js';
import TableOutlined from './svg/Outlined/Table.es.js';
import TableCellEditOutlined from './svg/Outlined/TableCellEdit.es.js';
import TableCellMergeOutlined from './svg/Outlined/TableCellMerge.es.js';
import TableCellSplitOutlined from './svg/Outlined/TableCellSplit.es.js';
import TableSettingOutlined from './svg/Outlined/TableSetting.es.js';
import TabletOutlined from './svg/Outlined/Tablet.es.js';
import TelephoneOutlined from './svg/Outlined/Telephone.es.js';
import TestimonialOutlined from './svg/Outlined/testimonial.es.js';
import TextOutlined from './svg/Outlined/Text.es.js';
import TextExpandOutlined from './svg/Outlined/TextExpand.es.js';
import TextUppercaseOutlined from './svg/Outlined/TextUppercase.es.js';
import TiviOutlined from './svg/Outlined/Tivi.es.js';
import TransactionHistoryOutlined from './svg/Outlined/Transaction-history.es.js';
import TrashBinDeleteRemoveOutlined from './svg/Outlined/Trash-Bin-Delete-Remove.es.js';
import TreeviewOutlined from './svg/Outlined/Treeview.es.js';
import TvNewOutlined from './svg/Outlined/TvNew.es.js';
import TwoColumnsLayoutOutlined from './svg/Outlined/two-columns-layout.es.js';
import UncheckedCheckboxOutlined from './svg/Outlined/UncheckedCheckbox.es.js';
import UnderlineOutlined from './svg/Outlined/underline.es.js';
import UndoOutlined from './svg/Outlined/Undo.es.js';
import UnionPaymentOutlined from './svg/Outlined/UnionPayment.es.js';
import UnlinkOutlined from './svg/Outlined/unlink.es.js';
import UnlockOutlined from './svg/Outlined/Unlock.es.js';
import UpLineOutlined from './svg/Outlined/Up-Line.es.js';
import UpOutlined from './svg/Outlined/Up.es.js';
import UploadOutlined from './svg/Outlined/Upload.es.js';
import VideoClipOutlined from './svg/Outlined/VideoClip.es.js';
import VoucherOutlined from './svg/Outlined/Voucher.es.js';
import WarehouseOutlined from './svg/Outlined/Warehouse.es.js';
import WashingOutlined from './svg/Outlined/Washing.es.js';
import WebcamOutlined from './svg/Outlined/Webcam.es.js';

const mappingIcon = {
  AddAlternativeOutlined,
  ClockAlternativeOutlined,
  DirectionAlternativeOutlined,
  FavouriteAlternativeOutlined,
  FormScaleAlternativeOutlined,
  HomepageAlternativeOutlined,
  LaptopAlternativeOutlined,
  MarkAsReadAlternativeOutlined,
  RatingAlternativeOutlined,
  SettingAlternativeOutlined,
  SuccessAlternativeOutlined,
  AccordionOutlined,
  AccountOutlined,
  AddItemOutlined,
  AddOutlined,
  AdvisoryOutlined,
  AlignCenterOutlined,
  AlignJustifyOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  ArrowUpOutlined,
  BackToTopOutlined,
  BackOutlined,
  BagCheckmarkOutlined,
  BlockGroupOutlined,
  BoldOutlined,
  BookOutlined,
  BoxOutlined,
  BuildPcOutlined,
  BulletedListOutlined,
  BusinessCustomerOutlined,
  BusinessSolutionOutlined,
  ButtonOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  CalendarWorkForWeekOutlined,
  CameraOutlined,
  CartOutlined,
  CashOutlined,
  CautionOutlined,
  ChatOutlined,
  CheckOutlined,
  ChecklistOutlined,
  ChevronDownOutlined,
  ChevronUpOutlined,
  ChipOutlined,
  CircleBackOutlined,
  CircleDownOutlined,
  CircleForwardOutlined,
  CircleUpOutlined,
  CloseOutlined,
  CloudArrowUpOutlined,
  CodeOutlined,
  ColorSwitchOutlined,
  ContentSettingsOutlined,
  CopyOutlined,
  CustomerSupportOutlined,
  DataTreemapOutlined,
  DeleteOutlined,
  DeleteColumnOutlined,
  DeleteRowOutlined,
  DesktopOutlined,
  DinoOutlined,
  DiscountTagOutlined,
  DiscountOutlined,
  DividerOutlined,
  DocumentOutlined,
  DotOutlined,
  DownLineOutlined,
  DownOutlined,
  DownloadOutlined,
  DragOutlined,
  DragdropOutlined,
  DuplicateOutlined,
  EditColumnOutlined,
  EditSquareOutlined,
  EditOutlined,
  EndShiftOutlined,
  ExportFileOutlined,
  EyeOutlined,
  FaceIdOutlined,
  FileOutlined,
  FillColorShapeOutlined,
  FillColorTextOutlined,
  FilterOutlined,
  FingerPrintOutlined,
  FluentButtonOutlined,
  FluentLinkOutlined,
  FormOutlined,
  FormatTextLeftOutlined,
  FormatTextRightOutlined,
  ForwardOutlined,
  GamingOutlined,
  GarbageOutlined,
  GoldOutlined,
  GuaranteeCheckedOutlined,
  HamburgerOutlined,
  HeaderOutlined,
  HeadingOutlined,
  HeadphoneOutlined,
  HideOutlined,
  HOneOutlined,
  HThreeOutlined,
  HTwoOutlined,
  IdCardOutlined,
  ImageOutlined,
  InforOutlined,
  InsertColumnAfterOutlined,
  InsertColumnBeforeOutlined,
  InsertRowAboveOutlined,
  InsertRowBelowOutlined,
  InstallmentOutlined,
  InstallmentCalendarOutlined,
  InternetOutlined,
  ItalicOutlined,
  JumpForwardOutlined,
  JumpBackOutlined,
  JumpForwardAlternativeOutlined,
  LeftLineOutlined,
  LeftOutlined,
  LineOutlined,
  LineDashedOutlined,
  LineDottedOutlined,
  LineThroughOutlined,
  LinkOutlined,
  ListLocationOutlined,
  ListOutlined,
  LocationOutlined,
  LockOutlined,
  LogOutOutlined,
  LoyaltyOutlined,
  MailOutlined,
  MenuOutlined,
  MinusCircleOutlined,
  MinusRetangleOutlined,
  MinusOutlined,
  MobileAndDesktopOutlined,
  MobiphoneOutlined,
  MoneyTransferOutlined,
  MonitorOutlined,
  MoreInforOutlined,
  MoreProductOutlined,
  NewsOutlined,
  NoneOutlined,
  NotificationsOutlined,
  NumberedListOutlined,
  OrderOutlined,
  PageOutlined,
  ParagraphOutlined,
  PauseOutlined,
  PaymentOutlined,
  PbArrowLeftOutlined,
  PbLinkOutlined,
  PbUnlinkOutlined,
  PcOutlined,
  PhoneOutlined,
  PlayOutlined,
  PlusCircleOutlined,
  PlusRetangleOutlined,
  PopupOutlined,
  PrinterOutlined,
  ProductOutlined,
  ProfileOutlined,
  PromoOutlined,
  PromoDiscountOutlined,
  QaOutlined,
  QrCodeScanOutlined,
  RamOutlined,
  RedoOutlined,
  RefreshOutlined,
  RefundOutlined,
  ResizeSmallOutlined,
  ReturnItemOutlined,
  RightLineOutlined,
  RightOutlined,
  RowTripleOutlined,
  SaveOutlined,
  ScanningOutlined,
  SearchOutlined,
  SettingsOutlined,
  ShareOutlined,
  ShieldOutlined,
  ShippingOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ShortingOutlined,
  ShowOutlined,
  ShowroomOutlined,
  SlideTextOutlined,
  SpacerOutlined,
  SpeakerOutlined,
  SplitHorizontalOutlined,
  SquareMultipleOutlined,
  StarEmphasisOutlined,
  StopOutlined,
  SwitchOutlined,
  SyncOutlined,
  TabOutlined,
  TableOutlined,
  TableCellEditOutlined,
  TableCellMergeOutlined,
  TableCellSplitOutlined,
  TableSettingOutlined,
  TabletOutlined,
  TelephoneOutlined,
  TestimonialOutlined,
  TextOutlined,
  TextExpandOutlined,
  TextUppercaseOutlined,
  TiviOutlined,
  TransactionHistoryOutlined,
  TrashBinDeleteRemoveOutlined,
  TreeviewOutlined,
  TvNewOutlined,
  TwoColumnsLayoutOutlined,
  UncheckedCheckboxOutlined,
  UnderlineOutlined,
  UndoOutlined,
  UnionPaymentOutlined,
  UnlinkOutlined,
  UnlockOutlined,
  UpLineOutlined,
  UpOutlined,
  UploadOutlined,
  VideoClipOutlined,
  VoucherOutlined,
  WarehouseOutlined,
  WashingOutlined,
  WebcamOutlined,
  AppListFilled,
  DirectionFilled,
  AccountFilled,
  ArrowDownTinyFilled,
  ArrowDownFilled,
  ArrowLeftTinyFilled,
  ArrowLeftFilled,
  ArrowRightTinyFilled,
  ArrowRightFilled,
  ArrowUpTinyFilled,
  ArrowUpFilled,
  CalendarFilled,
  CartFilled,
  CautionFilled,
  ChevronDownFilled,
  ChevronUpFilled,
  ClockFilled,
  CopyFilled,
  DeleteCircleFilled,
  DeleteFilled,
  DiscountTagFilled,
  DiscountFilled,
  DoubleArrowTinyFilled,
  DoubleArrowFilled,
  EditFilled,
  EyeHideFilled,
  EyeShowFilled,
  FacebookMessengerFilled,
  FacebookFilled,
  FavouriteFilled,
  FilterFilled,
  FlashSaleFilled,
  FlashOffFilled,
  FlashOnFilled,
  FourColumnsDevFilled,
  GarbageFilled,
  GithubFilled,
  GlobalFilled,
  GoogleFilled,
  HighlightBackgroundFilled,
  HomepageFilled,
  ImageFilled,
  InforFilled,
  InstagramFilled,
  LayerFilled,
  LeftAndRightSidebarDevFilled,
  LeftSidebarDevFilled,
  MoreProductFilled,
  NotificationFilled,
  NumberCounterFilled,
  OneColumnDevFilled,
  OptionsFilled,
  OrderFilled,
  PbCallFilled,
  PbInpageLinkFilled,
  PbMailFilled,
  PbNavigationCurvedFilled,
  PbNavigationRoundFilled,
  PbPaginationDotBigFilled,
  PbPaginationDotLineFilled,
  PbPaginationDotsFilled,
  PbPaginationLineFilled,
  PbSliderOneRowFilled,
  PbSliderThreeRowFilled,
  PbSliderTwoRowFilled,
  PhoneFilled,
  ProfileFilled,
  PromoFilled,
  RatingFilled,
  RightSidebarDevFilled,
  SaveFilled,
  SettingsFilled,
  SixColumnDevFilled,
  SliderFilled,
  SuccessFilled,
  ThreeColumnsDevFilled,
  TickFilled,
  TiktokFilled,
  TwitterFilled,
  TwoColumnsFilled,
  TwoColumnsDevFilled,
  TwoSmallColumnLeftDevFilled,
  TwoSmallColumnRightDevFilled,
  VoucherFilled,
  YoutubeFilled,
  ZaloFilled,
  ApiCodeColored,
  AtmCardColored,
  AtmColored,
  BadgesColored,
  BankColored,
  CashColored,
  CircleBankColored,
  CircleCashColored,
  CircleMobileBankingColored,
  CircleQrCodeColored,
  CircleShippingColored,
  CircleShowroomColored,
  CircleVisaLogoColored,
  DeleteCircleColored,
  DinoColored,
  DiscountTagColored,
  FireFlashsaleColored,
  FreeShippingColored,
  GoogleSheetColored,
  GoogleGmailColored,
  GuaranteeCheckedColored,
  IndicatorColored,
  LuckyDrawColored,
  LuckySpinColored,
  MasterCardColored,
  MobileBankingColored,
  PaymentColored,
  PvShowroomColored,
  QrCodeColored,
  RewardGoldenColored,
  RewardBronzeCircleColored,
  RewardBronzeColored,
  RewardGoldenCircleColored,
  RewardPlatinumCircleColored,
  RewardPlatinumColored,
  RewardSilverCircleColored,
  RewardSilverColored,
  SaleColored,
  ShippingColored,
  ShopColored,
  ShoppingCartColored,
  StarColored,
  SuccessColored,
  UsaColored,
  VietnamColored,
  VisaCardColored,
  VisaLogoColored,
  VoucherColored,
  WalletColored
};

export { mappingIcon };
